import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin } from 'antd'
import { Bar } from '@antv/g2plot';
import Card from '@/pages/Tbqy/components/components/Card'
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'

const data = [];

for(let i=0; i<12; i++) {
  data.push({
    "label": i+ 1 + "所",
    "type": "本年利润(万)",
    "value": Math.floor(Math.random()*100)
  })
}

const tabsOptions = [
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const containerRef = useRef()
  const [loading, setLoading] = useState(false)
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    column: null as Bar,
    loadTime: updateTime
  })

  useEffect(() => {
    globalRef.current.column = new Bar(containerRef.current, {
      data,
      xField: 'value',
      yField: 'label',
      seriesField: 'type',
      isGroup: true,
      legend: {
        position: 'bottom',
      },
    });

    globalRef.current.column.render();
    globalRef.current.column.changeData(data)
  }, [])
  
  // 获取图表数据
  const getColumnData = useCallback(async () => {
    const tabOption = tabsOptions.find(t => t.value === globalRef.current.params.tab)
    if(!tabOption || !tabOption.api) {
      return
    }

    const res = await tabOption.api()
    if(res.success) {
      globalRef.current.column.changeData(res.data.list.reduce((c, n) => {
        c.push({
          label: n.time,
          value: n.jnZBnum || n.jnTBnum || 0,
          type: '今年'
        })
        c.push({
          label: n.time,
          value: n.qnZBnum || n.qnTBnum || 0,
          type: '去年'
        })
        return c
      }, []))
    }
  }, [])

  // 获取统计数据
  const getTotal = useCallback(async () => {
    
  }, [])

  // 获取接口数据
  const getList = useCallback(async () => {
    setLoading(true)
    Promise.all([getColumnData(), getTotal()]).finally(() => {
      setLoading(false)
    })
  }, [getColumnData, getTotal])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.params = value
    getList()
  }, [getList])

  useEffect(() => {
    if(globalRef.current.loadTime !== updateTime) {
      globalRef.current.loadTime = updateTime
      getList()
    }
  }, [updateTime, getList])

  return (
    <Spin spinning={loading} wrapperClassName='full-spin'>
      <Card title="部门利润排行" className='full-card' hasExport={false}>
        <CardContainer
          tabs={tabsOptions}
          onTabChange={handleTabChange}
          hasExport={false}
        >
          <div className='h-full pt-20'>
            <div className='h-full' ref={containerRef}></div>
          </div>
        </CardContainer>
      </Card>
    </Spin>
  )
}

export default Component
